const PriceLists = () => import("./views/PriceLists.vue");
const PriceListEdit = () => import("./views/PriceListEdit.vue");
const PriceListsGroups = () => import("./views/PriceListsGroups.vue");
const PriceListsGroupEdit = () => import("./views/PriceListsGroupEdit.vue");

const route = "/priceLists";
const groupsRoute = "/priceListsGroups";

export default [
  {
    path: route,
    name: "priceLists.list",

    component: PriceLists,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create/:priceListId?`,
    name: "priceLists.create",
    component: PriceListEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:priceListId/edit`,
    name: "priceLists.edit",
    component: PriceListEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: groupsRoute,
    name: "priceListsGroups.list",
    component: PriceListsGroups,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${groupsRoute}/create`,
    name: "priceListsGroups.create",
    component: PriceListsGroupEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${groupsRoute}/:priceListsGroupId/edit`,
    name: "priceListsGroups.edit",
    component: PriceListsGroupEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
